module.exports = __webpack_public_path__ + "f.no2.86f6ef3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/f.no2.jpg
// module id = CjQN
// module chunks = 0